import { useMutation } from "react-query";

import { ServiceSupplier } from "@bcasmart/doxecure-commons/doxecureTypes";

import { useAuthContext } from "@hooks/useAuthContext";
import { connectUserToDrive } from "@services/drive.service";

export const useConnectToDrive = () => {
    const { connectedProfileId } = useAuthContext();

    return useMutation(({ provider, redirectUri }: { provider: ServiceSupplier; redirectUri: string }) =>
        connectUserToDrive(connectedProfileId, provider, redirectUri)
    );
}